import React from 'react'
import { ThemeProvider } from '@/lib/styles'

function SignupPage() {
  return <ThemeProvider></ThemeProvider>
}

export default SignupPage
